import { setEcSdkData } from '../../reducers/ecSdk/ecSdkSlice'

// Handle EC SDK Data
export const handleEcSdkData = (data) => {
  return (dispatch) => {
    dispatch(setEcSdkData(data))
  }
}

export default handleEcSdkData
